// extracted by mini-css-extract-plugin
export default {"cls1":"_qoMEwIiFvDc88op4j3K","cls2":"llGofKVFNemjV6B92oe3 _qoMEwIiFvDc88op4j3K"};